import React from 'react'
import { isProponente, isDestinatario } from '../../utils'
import { themeColors } from '../../styles/theme'

const SwapTextualDescription = ({ swap, user }) => {
  if (isProponente(swap, user)) {
    return (
      <span>
        Stai chiedendo {' '}
        <span style={{ color: themeColors.secondary }}>
          {swap.destinatarioItems.length !== 1
            ? `${swap.destinatarioItems.length} oggetti`
            : 'un oggetto'}
        </span>
        {' '} di {' '}
        <span style={{ color: themeColors.secondary }}>
          {swap.destinatario.username}
        </span>
        {' '} in cambio di {' '}
        <span style={{ color: themeColors.primary }}>
          {swap.proponenteItems.length !== 1
            ? `${swap.proponenteItems.length}`
            : 'uno'}
        </span>
        {' '} dei tuoi
        {swap.proponenteMoney > 0 &&
          <span>
            {' '}
            e
            {' '}
            <span style={{ color: themeColors.primary }}>
              {swap.proponenteMoney} €
            </span>
          </span>}
        {'.'}
      </span>
    )
  } else if (isDestinatario(swap, user)) {
    return (
      <span>
        {swap.proponente.username} sta chiedendo {' '}
        <span style={{ color: themeColors.secondary }}>
          {swap.destinatarioItems.length !== 1
            ? `${swap.destinatarioItems.length} oggetti`
            : 'un oggetto'}
        </span>
        {' '} dei tuoi in cambio di {' '}
        <span style={{ color: themeColors.primary }}>
          {swap.proponenteItems.length !== 1
            ? `${swap.proponenteItems.length}`
            : 'uno'}
        </span>
        {' '} dei suoi
        {swap.proponenteMoney > 0 &&
          <span>
            {' '}
            e
            {' '}
            <span style={{ color: themeColors.primary }}>
              {swap.proponenteMoney} €
            </span>
          </span>}
        {'.'}
      </span>
    )
  }
  return null
}

export default SwapTextualDescription



// WEBPACK FOOTER //
// ./src/common/Swap/SwapTextualDescription.js